import React from 'react'
import { FormattedMessage } from 'react-intl'

export const SLOT_TOOLTIP_MESSAGE = (
    <FormattedMessage
        id='slot_tooltip.message'
        defaultMessage='Нажмите, чтобы выбрать и возвести новое строение на этом месте.'
    />
)

export const SLOT_TOOLTIP_MESSAGE_NO_PERMISSION = (
    <FormattedMessage
        id='slot_tooltip.message_no_permission'
        defaultMessage='Нажмите, чтобы просмотреть список невозведённых строений.'
    />
)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/SlotTooltip/constants.jsx